import { Button, LuIcon, Text } from "@overmap-ai/blocks"
import { selectFormById } from "@overmap-ai/core"
import { getRouteApi, Link } from "@tanstack/react-router"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { useAppSelector } from "../../store"
import { BaseTopBar } from "../TopBars/BaseTopBar"

const routeApi = getRouteApi("/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/identifiers")

export const FormSettingsIdentifiersViewTopBar = memo(() => {
	const { formId } = routeApi.useParams()

	const form = useAppSelector(selectFormById(formId))

	return (
		<BaseTopBar
			showAIButton={false}
			leftContent={
				<Link
					from="/$organizationId/settings/forms/$formId/identifiers"
					to="/$organizationId/settings/forms/$formId"
				>
					<Button>
						<LuIcon icon={modelIconMapping.arrowLeft} />
						<LuIcon icon={modelIconMapping.form} />
						<Text className="truncate">{form?.name}</Text>
					</Button>
				</Link>
			}
		/>
	)
})
FormSettingsIdentifiersViewTopBar.displayName = "FormSettingsIdentifiersViewTopBar"
